import { createSlice } from '@reduxjs/toolkit'
import { fetchPreferences } from './Preferences/preferences'
import { userActions } from '../_actions'

const initialState = {
	isAppReady: false,
}

const slice = createSlice({
	name: 'init',
	initialState,
	reducers: {
		setAppReady(state, action) {
			state.isAppReady = action.payload
		},
	},
})

export const { reducer, actions } = slice

export const initApp = () => async (dispatch) => {
	await Promise.all([dispatch(fetchPreferences()), dispatch(userActions.getLicenses())])

	dispatch(actions.setAppReady(true))
}
